import { Slider } from '@nextui-org/react';

export function sliderChangeValue(value: number | number[]): number {
  return Array.isArray(value) ? value[0] : value;
}

function formatSliderNumber(value: number, step: number): string {
  if (step >= 1) return String(Math.round(value));
  const decimals = String(step).includes('.') ? String(step).split('.')[1].length : 1;
  return value.toFixed(decimals);
}

interface AdvanceSliderProps {
  label: string;
  ariaLabel?: string;
  minValue: number;
  maxValue: number;
  step: number;
  value: number;
  onChange: (value: number) => void;
  valueSuffix?: string;
  showSteps?: boolean;
}

/** Shared Advance-tab slider with current value and visible min–max range. */
export function AdvanceSlider({
  label,
  ariaLabel,
  minValue,
  maxValue,
  step,
  value,
  onChange,
  valueSuffix = '',
  showSteps = false,
}: Readonly<AdvanceSliderProps>) {
  const display = `${formatSliderNumber(value, step)}${valueSuffix}`;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm text-foreground">{label}</span>
        <span className="text-sm font-medium text-foreground">{display}</span>
      </div>
      <Slider
        aria-label={ariaLabel ?? label}
        minValue={minValue}
        maxValue={maxValue}
        step={step}
        value={value}
        onChange={(next) => onChange(sliderChangeValue(next))}
        color="primary"
        showSteps={showSteps}
        showTooltip
        size="md"
        className="max-w-full"
      />
      <div className="flex items-center justify-between text-xs text-default-500">
        <span>
          {formatSliderNumber(minValue, step)}
          {valueSuffix}
        </span>
        <span>
          {formatSliderNumber(maxValue, step)}
          {valueSuffix}
        </span>
      </div>
    </div>
  );
}
